import React from "react"
import {useTranslation} from "next-i18next"
import Typography from "../../reusable/Typography/Typography"
import Image from "next/image"
import NavLink from "../../reusable/components/NavLink/NavLink"
import urlParams from "../../../utility/UrlParams"
import ToggleItem from "../../reusable/components/ToggleItem"

type Props ={
    faqData?: {id: number, title: string, content: string}[]
    links?:{id: number, label:string, params: {}}[]
}

const MotorContent = ({faqData, links}: Props): React.ReactElement => {
	const {t} = useTranslation("consultationPage")

	return (
		<>
			<Typography style={{marginBottom: "32px"}}
				variant="heading28To36"
				semanticTag="h2">{t("motor")}</Typography>
			<Typography className="mb-1"
				variant="bodyLg"
				semanticTag="p">{t("motor-para-1")}</Typography>
			<Typography style={{marginTop: "40px"}}
				className="mb-4"
				variant="heading20To28"
				semanticTag="h2">{t("motor-heading-2")}</Typography>
			<Typography variant="bodyLg"
				semanticTag="p">{t("motor-para-2-1")}</Typography>
			<ul className="mb-3">
				<Typography variant="bodyLg"
					semanticTag="li">Bosch</Typography>
				<Typography variant="bodyLg"
					semanticTag="li">Shimano</Typography>
				<Typography variant="bodyLg"
					semanticTag="li">Bafang</Typography>
				<Typography variant="bodyLg"
					semanticTag="li">Simplo</Typography>
			</ul>

			<Typography variant="bodyLg"
				semanticTag="p">{t("motor-para-2-2")}</Typography>

			<div className="d-flex justify-content-center my-5">

				<Image src="/assets/images/consultation-page/motor.jpg"
					width={343}
					height={206}
					objectFit="contain"
					objectPosition="top right"/>
			</div>
			<Typography style={{marginTop: "40px"}}
				className="mb-4"
				variant="heading20To28"
				semanticTag="h2">{t("motor-heading-3")}</Typography>
			<Typography variant="bodyLg"
				semanticTag="p">{t("motor-para-3-1")}</Typography>
			<Typography variant="bodyLg"
				semanticTag="p">{t("motor-para-3-2")}</Typography>
			<Typography variant="bodyLg"
				semanticTag="p">{t("motor-para-3-3")}</Typography>
			<Typography variant="bodyLg"
				semanticTag="p">{t("motor-para-3-4")}</Typography>

			<Typography style={{marginTop: "40px"}}
				className="mb-4"
				variant="heading20To28"
				semanticTag="h2">{t("motor-heading-4")}</Typography>
			<ul className={"col-12 faq-list list-unstyled pt-2 pt-md-5"}>
				{faqData.map(item => {
					const {id, content, title} = item
					return <ToggleItem
						key={id}
						t={t}
						label={title}
						titleClasses="ms-0">
						<Typography variant="bodyLg">{t(content)}</Typography>
					</ToggleItem>
				})}
			</ul>
			<Typography style={{marginTop: "40px"}}
				className="mb-4"
				variant="heading20To28"
				semanticTag="h3">{t("motor-heading-5")}</Typography>
			<ul className="list-unstyled row col-md-8">
				{links.map(({id, label, params}) => <NavLink isNewLinkDesign
					translate={t}
					className="mb-4 col-12 col-md-6"
					key={id}
					params={params}
					label={label}/>)}
			</ul>
		</>)
}

export default MotorContent

MotorContent.defaultProps = {
	faqData: [
		{id: 1, title: "motor-faq-1-title", content: "motor-faq-1-content"},
		{id: 2, title: "motor-faq-2-title", content: "motor-faq-2-content"},
		{id: 3, title: "motor-faq-3-title", content: "motor-faq-3-content"}
	], links: [
		{id: 1, label: "motor-link-1", params: {[urlParams.categories]: "e-urban", [urlParams.motorBrand]: "bosch"}},
		{id: 3, label: "motor-link-3", params: {[urlParams.categories]: "e-trekking", [urlParams.motorBrand]: "bosch"}},
		{id: 4, label: "motor-link-4", params: {[urlParams.categories]: "e-trekking", [urlParams.motorBrand]: "shimano"}},
		{id: 5, label: "motor-link-5", params: {[urlParams.categories]: "e-mountain", [urlParams.motorBrand]: "bosch"}},
		{id: 6, label: "motor-link-6", params: {[urlParams.categories]: "e-mountain", [urlParams.motorBrand]: "shimano"}}
	]
}
